import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travellerEntity: Entity = {
  model: model,
  repository: repository,
}

export default travellerEntity
